import * as React from 'react'
import styled from 'styled-components'
import I18n from 'core/i18n'
import { IJsonResponse } from 'core/JsonApiSerializer'
import { utilService } from 'core/services'
import * as interfaces from 'static/interfaces'
import { Button, Pagination, Panel } from 'components/atoms'
import SidebarLayout from 'components/pages/_layouts/sidebarLayout'
import SvgIcon from 'components/atoms/SvgIcon'
import { ReviewCard } from 'components/molecules/ReviewCard'
import GuideProfilePanel from './parts/GuideProfilePanel'
import ReviewRatingFilter from './parts/ReviewRatingFilter'

interface IReviewSummary {
  count: number
  average: number
  mapping: Record<string, number>
}

interface IProps {
  user: IJsonResponse
  guide: IJsonResponse
  review_summary: IReviewSummary
  reviews: IJsonResponse
}

// AgentGuideProfile : agent 向けのガイドのプロフィール。星で絞り込めるレビュー一覧も表示する.
const AgentGuideProfile: React.FC<IProps> = props => {
  const { data: user } = utilService.getDataFromJson(props.user)
  const { data: guide } = utilService.getDataFromJson(props.guide)
  const { data: reviews } = utilService.getDataFromJson(props.reviews)
  const selectedRating = new URLSearchParams(window.location.search).get('rating') || ''
  const summary = props.review_summary
  const meta = props.reviews.meta

  // rating の絞り込みを保ったままページを移動する
  const movePage = (page: number) => {
    const params = new URLSearchParams(window.location.search)
    params.set('page', String(page))
    window.location.search = params.toString()
  }

  return (
    <SidebarLayout user={user}>
      <Content>
        <div>
          <Button>
            <a href="/agent/guides">
              <SvgIcon
                name="keyboard_arrow_left"
                className="icon"
                ariaHidden={true}
                role="presentation"
              />
              {I18n.t('generic.back_to_index')}
            </a>
          </Button>
        </div>
        <GuideProfilePanel
          guide={guide}
          averageReview={summary.average}
          reviewCount={summary.count}
        />
        <Panel title={I18n.t('generic.user_reviews_list', { username: guide.username })}>
          <ReviewRatingFilter
            reviewMapping={summary.mapping}
            reviewCount={summary.count}
            selectedRating={selectedRating}
          />
          <Reviews>
            {reviews.map((review: interfaces.IReview) => (
              <ReviewCard key={review.id} review={review} showReply={true} />
            ))}
          </Reviews>
          {meta && (
            <Pagination
              onChangePageHandler={movePage}
              currentPage={meta.current_page}
              prevPage={meta.prev_page}
              nextPage={meta.next_page}
              totalPages={meta.total_pages}
              totalCount={meta.total_count}
            />
          )}
        </Panel>
      </Content>
    </SidebarLayout>
  )
}

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  max-width: 960px;
  margin: auto;
  padding: 32px 16px;

  .Panel.default {
    margin: 0;
  }
`

const Reviews = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 24px 0;
`

export default AgentGuideProfile
